/* eslint no-console: "off" */
import { get } from 'lodash';

import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { closeNotification, danger, success } from 'redux-store/reducers/common-reducer';

import { API, patch, post } from 'utils/api';
import { t } from 'utils/language';
import { logError } from 'utils/log';

const { REQUEST_PASSWORD_RESET, NEW_USERS } = API.END_POINTS.API;

export function submitReset({ id, token, password }) {
  const url = `${NEW_USERS}/${id}`;
  const data = { password };

  const headers = {
    'Authorization': token,
    'X-Password-Op-Kind': 'reset'
  };

  // doesn't really suppress but allows a custom auth header to take place
  const suppressAuth = true;

  return async dispatch => {
    try {
      if (!token || !id) {
        throw new Error(t('invalid_password_reset_url'));
      }

      dispatch(showLoading(url));

      await patch(url, { data, headers }, { suppressAuth });
    } catch (error) {
      dispatch(danger(error.response ? t('invalid_password_reset_url') : error.message));
      logError(error);
      throw error;
    } finally {
      dispatch(hideLoading(url));
    }
  };
}

export function requestPasswordReset(params) {
  const url = REQUEST_PASSWORD_RESET;

  return (dispatch) => {
    dispatch(showLoading(url));

    grecaptcha.ready(() => {
      grecaptcha.execute(window.app.env.CAPTCHA_SITE_KEY, { action: 'password_reset' }).then(captchaToken => {
        const dataWithToken = {
          action: 'password_reset_request',
          captchaToken,
          data: params.email
        };

        post(url, { data: dataWithToken }, { suppressAuth: true })
          .then(() => {
            dispatch(success(params.successMessage));
            dispatch(hideLoading(url));
          })
          .catch((error) => {
            logError(error);
            dispatch(closeNotification());
            const requestEmailActivation = `<a href="/users/request-activation-email">
                ${t('click_here_to_resend_activation_email')}</a>
              `;
            dispatch(danger(
              get(error, 'response.data.code') === 'auth.inactive_user' ?
                `${t('user_account_not_active')} ${requestEmailActivation}` :
                t('request_password_reset_invalid_email'
                ))
            );
            dispatch(hideLoading(url));
          });
      });
    });
  };
}
